import React from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Input, Modal } from 'antd';
import { useCreateGroupMutation, useUpdateGroupMutation } from '../../redux/Api/UserManagment/uMGroupsApiSlice';
import PermissionsDropdown from '../PermissionsDropdown'
import { toast } from 'react-toastify';
import Loader from '../../pages/pages/loader';

const EditCreateGroups = ({ state, open, setOpen, group }) => {
    const [createGroup, { isLoading: isCreating }] = useCreateGroupMutation()
    const [updateGroup, { isLoading: isUpdating }] = useUpdateGroupMutation()

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: group ? group.name : "",
            permissions: group ? group.permissions : [],
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Name is required'),
            permissions: Yup.array().nullable()
        }),
        onSubmit: async (values) => {
            try {
                if (state === "edit") {
                    await updateGroup({ id: group?.id, data: values }).unwrap()
                    toast.success('Group updated successfully')
                }
                if (state === "create") {
                    await createGroup(values).unwrap()
                    toast.success('Group created successfully')
                }
                setOpen(false)
            } catch (error) {
                if (error?.data) {
                    const errorMessages = Object.values(error.data).flat()
                    errorMessages.forEach(message => {
                        toast.error(message)
                    })
                } else {
                    toast.error('Failed to save group')
                }
            }
        },
    })

    return (
        <Modal
            className='customModal'
            open={open}
            title={state === "edit" ? "Edit Group" : "Add New Group"}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={isCreating || isUpdating} onClick={() => {
                    if (Object.keys(validation.errors).length !== 0) {
                        Object.keys(validation.errors).map((key) => {
                            toast.error(validation.errors[key]);
                        });
                        return;
                    }
                    validation.handleSubmit();
                }}>
                    Submit
                </Button>
            ]}
        >
            <Loader isLoading={isCreating || isUpdating} />
            <div className=" mb-3">
                <label className="" >Name</label>
                <Input
                    required
                    type="name"
                    name='name'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name}
                />
                {validation.touched.name &&
                    validation.errors.name ? (
                    <p className='text-danger'>
                        {validation.errors.name}
                    </p>
                ) : null}
            </div>
            <div>
                <PermissionsDropdown
                    onBlur={validation.handleBlur}
                    onChange={validation.setFieldValue}
                    value={validation.values.permissions}
                    name='permissions'
                />
                {validation.touched.permissions && validation.errors.permissions ? (
                    <p className='text-danger'>{validation.errors.permissions}</p>
                ) : null}
            </div>
        </Modal>
    )
}

export default EditCreateGroups